export const chooseAvatarAction = (
  avatar: Record<string, string>,
  selectorState: string
) => ({
  type: 'CHOOSE_AVATAR',
  payload: {
    id: avatar?.id,
    code: avatar?.code,
    name: avatar?.name,
    redirectLink: selectorState,
    chosenDisplay: 'avatar',
  },
});
export const chooseFamilyAvatarAction = (
  avatar: Record<string, string>,
  selectorState: string
) => ({
  type: 'CHOOSE_FAMILY_AVATAR',
  payload: {
    id: avatar?.id,
    code: avatar?.code,
    name: avatar?.name,
    redirectLink: selectorState,
    chosenDisplay: 'avatar',
  },
});

export const selectAvatarSkinToneAction = (
  avatarSkinTone: Record<string, string>
) => ({
  type: 'SELECT_AVATAR_SKIN_TONE',
  payload: {
    id: avatarSkinTone?.id,
    code: avatarSkinTone?.colorCode,
    name: avatarSkinTone?.name,
  },
});

export const selectFamilyAvatarSkinToneAction = (
  avatarSkinTone: Record<string, string>
) => ({
  type: 'SELECT_FAMILY_AVATAR_SKIN_TONE',
  payload: {
    id: avatarSkinTone?.id,
    code: avatarSkinTone?.colorCode,
    name: avatarSkinTone?.name,
  },
});

export const selectAvatarHairColorAction = (
  avatarHairColor: Record<string, string>
) => ({
  type: 'SELECT_AVATAR_HAIR_COLOR',
  payload: {
    id: avatarHairColor?.id,
    code: avatarHairColor?.colorCode,
    name: avatarHairColor?.name,
  },
});

export const selectFamilyAvatarHairColorAction = (
  avatarHairColor: Record<string, string>
) => ({
  type: 'SELECT_FAMILY_AVATAR_HAIR_COLOR',
  payload: {
    id: avatarHairColor?.id,
    code: avatarHairColor?.colorCode,
    name: avatarHairColor?.name,
  },
});

export const selectAvatarShirtColorAction = (
  avatarShirtColor: Record<string, string>
) => ({
  type: 'SELECT_AVATAR_SHIRT_COLOR',
  payload: {
    id: avatarShirtColor?.id,
    code: avatarShirtColor?.colorCode,
    name: avatarShirtColor?.name,
  },
});

export const selectFamilyAvatarShirtColorAction = (
  avatarShirtColor: Record<string, string>
) => ({
  type: 'SELECT_FAMILY_AVATAR_SHIRT_COLOR',
  payload: {
    id: avatarShirtColor?.id,
    code: avatarShirtColor?.colorCode,
    name: avatarShirtColor?.name,
  },
});

export const chooseDisplayPicture = (file: any) => ({
  type: 'SELECT_PICTURE',
  payload: {
    chosenDisplay: 'picture',
    objectURL: URL.createObjectURL(file),
    isCropped: false,
    fileName: file.name,
  },
});

export const storeCroppedImage = (croppedImage: any) => ({
  type: 'SAVE_CROPPED_IMAGE',
  payload: {
    croppedImage: croppedImage,
    isCropped: true,
  },
});

export const storeFamilyCroppedImage = (croppedImage: any) => ({
  type: 'SAVE_FAMILY_CROPPED_IMAGE',
  payload: {
    croppedImage: croppedImage,
    isCropped: true,
  },
});

export const createNewFamilyMember = () => ({
  type: 'CREATE_NEW_FAMILY_MEMBER',
});

export const chooseFamilyDisplayPicture = (file: any) => ({
  type: 'SELECT_FAMILY_PICTURE',
  payload: {
    chosenFamilyDisplay: 'picture',
    familyPictureObjectURL: URL.createObjectURL(file),
    isCropped: false,
    familyPictureName: file.name,
  },
});

export const resetChosenFamilyDisplay = () => ({
  type: 'RESET_CHOSEN_FAMILY_DISPLAY',
  payload: {
    chosenFamilyDisplay: '',
  },
});

export const resetFamilyDisplayPicture = () => ({
  type: 'RESET_FAMILY_DISPLAY_PICTURE',
  payload: {
    chosenFamilyDisplay: '',
  },
});

export const resetProfileUpload = () => ({
  type: 'RESET',
});

interface DependentDisplay {
  profilePicture: string;
  dependentDisplay: string;
  isFamilyCropped: boolean | '';
}

export const setDependentDisplay = ({ profilePicture, dependentDisplay, isFamilyCropped}: DependentDisplay) => ({
  type: 'SET_DEPENDENT_DISPLAY',
  payload: {
    croppedImage: profilePicture,
    chosenFamilyDisplay: dependentDisplay,
    isFamilyCropped: isFamilyCropped,
  },
});
